<template>
  <div>
    <hr>

    <!--  DataTable de Usuarios  -->
    <DataTable
      :data="usuariosFiltrados"
      :columns="columnasUsuario"
      idField="idUsuario"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="true"
      :acciones="true"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="false"
      mensajeVacio="No hay usuarios registrados."
      @refresh="getDataTodos"
      @edit="row => abrirModalEditar(row.idUsuario)"
    >
    </DataTable>

    <!-- Modal Usuario -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title">{{ titulo }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Perfil</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoUsuario.perfilNombre" disabled>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label">Nombre</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoUsuario.nombre" disabled>
                  </div>
                </div>
              </div>

              <hr>

              <!-- Módulos -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-3">
                    <input type="checkbox" id="moduloAdministracion" v-model="moduloAdministracionBoolean">
                    <label for="moduloAdministracion" class="form-label ms-2">Módulo Administración</label>
                  </div>
                  <div class="col-3">
                    <input type="checkbox" id="moduloAtencion" v-model="moduloAtencionBoolean">
                    <label for="moduloAtencion" class="form-label ms-2">Módulo Atención</label>
                  </div>
                  <div class="col-3">
                    <input type="checkbox" id="moduloFacturacion" v-model="moduloFacturacionBoolean">
                    <label for="moduloFacturacion" class="form-label ms-2">Módulo Facturación</label>
                  </div>
                  <div class="col-3">
                    <input type="checkbox" id="moduloDashboards" v-model="moduloDashboardsBoolean">
                    <label for="moduloDashboards" class="form-label ms-2">Módulo Dashboards</label>
                  </div>
                </div>
              </div>

              <!-- Menús -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-3">
                    <input type="checkbox" id="menuParametros" v-model="menuParametrosBoolean">
                    <label for="menuParametros" class="form-label ms-2">Menú Parámetros</label>
                  </div>
                  <div class="col-3">
                    <input type="checkbox" id="menuProcesos" v-model="menuProcesosBoolean">
                    <label for="menuProcesos" class="form-label ms-2">Menú Procesos</label>
                  </div>
                  <div class="col-3">
                    <input type="checkbox" id="menuReportes" v-model="menuReportesBoolean">
                    <label for="menuReportes" class="form-label ms-2">Menú Reportes</label>
                  </div>
                  <div class="col-3">
                    <input type="checkbox" id="menuAyuda" v-model="menuAyudaBoolean">
                    <label for="menuAyuda" class="form-label ms-2">Menú Ayuda</label>
                  </div>
                </div>
              </div>

              <!-- Opciones -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-3">
                    <input type="checkbox" id="opcionConsulta" v-model="opcionConsultaBoolean">
                    <label for="opcionConsulta" class="form-label ms-2">Opción Consulta</label>
                  </div>
                  <div class="col-3">
                    <input type="checkbox" id="opcionOperaciones" v-model="opcionOperacionesBoolean">
                    <label for="opcionOperaciones" class="form-label ms-2">Opción Operaciones</label>
                  </div>
                  <div class="col-3">
                    <input type="checkbox" id="opcionDescarga" v-model="opcionDescargaBoolean">
                    <label for="opcionDescarga" class="form-label ms-2">Opción Descarga</label>
                  </div>
                  <div class="col-3">
                    <input type="checkbox" id="opcionMenu" v-model="opcionMenuBoolean">
                    <label for="opcionMenu" class="form-label ms-2">Opción Menú</label>
                  </div>
                </div>
              </div>

              <hr>
              <button @click.prevent="mostrarOcultarBloque">
                {{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}
              </button>

              <div v-if="mostrarBloque" class="mb-3 mt-2">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label">IdUsuario</label>
                    <input type="text" class="form-control" v-model="datoUsuario.idUsuario" disabled>
                  </div>
                  <div class="col-2">
                    <label class="form-label">Suscripción</label>
                    <input type="text" class="form-control" v-model="datoUsuario.idSuscripcion" disabled>
                  </div>
                  <div class="col-2">
                    <label class="form-label">IdUsuarioReg</label>
                    <input type="text" class="form-control" v-model="datoUsuario.idUsuarioReg" disabled>
                  </div>
                  <div class="col-2">
                    <label class="form-label">FechaReg</label>
                    <input type="text" class="form-control" :value="getFormattedDate(datoUsuario.fechaReg)" disabled>
                  </div>
                  <div class="col-2">
                    <label class="form-label">IdUsuarioAct</label>
                    <input type="text" class="form-control" v-model="datoUsuario.idUsuarioAct" disabled>
                  </div>
                  <div class="col-2">
                    <label class="form-label">FechaAct</label>
                    <input type="text" class="form-control" :value="getFormattedDate(datoUsuario.fechaAct)" disabled>
                  </div>
                </div>
              </div>

            </div>
          </form>
          <div class="modal-footer">
            <button class="btn btn-light" @click.prevent="guardarUsuario" v-if="btnCrear" title="Guardar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
            </button>
            <button class="btn btn-light" @click.prevent="guardarEditUsuario" v-if="btnEditar" title="Actualizar">
              <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js'
import { createBooleanField } from '@/modules/casillaVerificacion.js'
import api from "@/services/api"
import * as $ from 'jquery'
window["$"] = $
window["jQuery"] = $
import swal from 'sweetalert'

export default {
  components: { DataTable },
  props: {
    p_idEmpresa: { type: Number, required: true },
  },
  data() {
    return {
      usuarios:       [],
      datoUsuario:    {},
      nombreBusqueda: '',
      titulo:         '',
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,
      mostrarBloque:  false,
      // Columnas del DataTable
      columnasUsuario: [
        { field: 'nombre',          label: 'Nombre' },
        { field: 'perfilNombre',    label: 'Perfil' },
        { field: 'personaDocumento', label: 'Documento' },
        { field: 'personaNombre',   label: 'Persona' },
      ],
    }
  },
  computed: {
    // Filtro por nombre aplicado sobre la lista completa
    usuariosFiltrados() {
      if (!this.nombreBusqueda.trim()) return this.usuarios
      const q = this.nombreBusqueda.toLowerCase()
      return this.usuarios.filter(u =>
        (u.nombre ?? '').toLowerCase().includes(q)
      )
    },
    moduloAdministracionBoolean: createBooleanField('moduloAdministracion'),
    moduloAtencionBoolean:       createBooleanField('moduloAtencion'),
    moduloFacturacionBoolean:    createBooleanField('moduloFacturacion'),
    moduloDashboardsBoolean:     createBooleanField('moduloDashboards'),
    menuParametrosBoolean:       createBooleanField('menuParametros'),
    menuProcesosBoolean:         createBooleanField('menuProcesos'),
    menuReportesBoolean:         createBooleanField('menuReportes'),
    menuAyudaBoolean:            createBooleanField('menuAyuda'),
    opcionConsultaBoolean:       createBooleanField('opcionConsulta'),
    opcionOperacionesBoolean:    createBooleanField('opcionOperaciones'),
    opcionDescargaBoolean:       createBooleanField('opcionDescarga'),
    opcionMenuBoolean:           createBooleanField('opcionMenu'),
    suscriptorBoolean:           createBooleanField('suscriptor'),
  },
  mounted() {
    this.getDataTodos()
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque
    },
    // Carga todos los usuarios de la empresa
    getDataTodos() {
      this.nombreBusqueda = ''
      api.get('/vwusuarios/idempresa/' + this.p_idEmpresa).then(response => {
        this.usuarios = response.data.reverse()
      })
    },
    validarForm() {
      return validarForm(
        this.datoUsuario,
        ['idPerfil','idSuscripcion','nombre','clave','moduloAdministracion',
         'moduloAtencion','moduloFacturacion','moduloDashboards','menuParametros',
         'menuProcesos','menuReportes','menuAyuda','opcionConsulta',
         'opcionOperaciones','opcionDescarga','opcionMenu','idPersona'],
        ['idEmpresa','idPerfil','idSuscripcion','nombre','clave','moduloAdministracion',
         'moduloAtencion','moduloFacturacion','moduloDashboards','menuParametros',
         'menuProcesos','menuReportes','menuAyuda','opcionConsulta',
         'opcionOperaciones','opcionDescarga','opcionMenu','idPersona']
      )
    },
    async guardarUsuario() {
      if (this.validarForm() !== 1) return
      try {
        this.datoUsuario.idUsuario    = window.sessionStorage.getItem("idUsuario")
        this.datoUsuario.idEmpresa    = window.sessionStorage.getItem("idEmpresa")
        this.datoUsuario.idUsuarioReg = window.sessionStorage.getItem("idUsuarioReg")
        await api.post('/usuarios', this.datoUsuario)
        $('#ventanaModal').modal('hide')
        swal("Correcto!", "Usuario creado exitosamente!", "success")
        this.getDataTodos()
      } catch {
        swal("Error!", "Intentelo de nuevo!", "error")
      }
    },
    async guardarEditUsuario() {
      if (this.validarForm() !== 1) return
      try {
        this.datoUsuario.idUsuarioAct = window.sessionStorage.getItem("idUsuarioAct")
        await api.post('/usuarios', this.datoUsuario)
        $('#ventanaModal').modal('hide')
        swal("Correcto!", "Usuario actualizado exitosamente!", "success")
        this.getDataTodos()
      } catch (error) {
        swal("Error!", "Intentelo de nuevo!", "error")
        Object.values(error.response?.data?.errors ?? {}).forEach(e => swal(String(e)))
      }
    },
    abrirModalEditar(idUsuario) {
      this.titulo    = 'Editar Usuario'
      this.btnCrear  = false
      this.btnEditar = true
      if (idUsuario) {
        api.get('/vwusuarios/' + idUsuario).then(resp => {
          this.datoUsuario = resp.data
        })
      }
      this.$nextTick(() => $('#ventanaModal').modal('show'))
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>